import { IAdvancedRole } from '@/features/roles/store/models/advancedRole.model';
import { IFeature } from '@/features/roles/store/models/features.model';

export function RoleOption(role: IAdvancedRole<IFeature>) {
  return (
    <div className="px-4 py-3 w-[340px] cursor-pointer group hover:bg-secondary text-secondary">
      {role && (
        <div>
          <div className="typo-body-bold-paragraph group-hover:text-interactive">{role.name}</div>
          <div className="typo-body-regular-caption">{role.description}</div>
        </div>
      )}
    </div>
  );
}

export function RoleSelectedOption(role: IAdvancedRole<IFeature>) {
  return (
    <div className="px[13px] py-[6px]">
      {role && (
        <div>
          <div className="typo-body-regular-paragraph">{role.name}</div>
        </div>
      )}
    </div>
  );
}
